module.exports = __webpack_public_path__ + "static/media/rush_bookmark_x_front2_2x.b7093e9b.jpg";